var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTxt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE6\x96\x87\xE6\xA1\xA3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.7971 1.20001C4.1041 1.20001 3.6001 1.76701 3.6001 2.39701V33.645C3.6001 34.338 4.1671 34.842 4.7971 34.842H31.7611C32.4541 34.842 32.9581 34.275 32.9581 33.645V8.57101L25.6501 1.20001H4.7971Z",
    fill: "url(#paint0_linear_1233_7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter0_d_1233_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5869 1.20001V7.31101C25.5869 8.00401 26.1539 8.50801 26.7839 8.50801H32.8949L25.5869 1.20001Z",
    fill: "#93BBFB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000000971"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 613",
    x: 9.6001,
    y: 13.8,
    width: 16.8,
    height: 1.8,
    rx: 0.9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 614",
    x: 9.6001,
    y: 17.4,
    width: 16.8,
    height: 1.8,
    rx: 0.9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 616",
    x: 9.6001,
    y: 21,
    width: 16.8,
    height: 1.8,
    rx: 0.9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 615",
    x: 9.6001,
    y: 24.6,
    width: 10.2,
    height: 1.8,
    rx: 0.9,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1233_7",
    x: 24.3869,
    y: 0.600012,
    width: 9.70811,
    height: 9.70798,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1233_7"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1233_7",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1233_7",
    x1: 18.2791,
    y1: 1.20001,
    x2: 18.2791,
    y2: 34.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#528BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A7EF2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.85c500ef357e526d94040d58ced40728.svg";
export { ForwardRef as ReactComponent };